import AiStudioMenuIcon from 'assets/images/others/ai-studio.svg';
import DamMenuIcon from 'assets/images/others/dam.svg';
import ConfiguratorMenuIcon from 'assets/images/others/product-configurator.svg';
import CustomizerMenuIcon from 'assets/images/others/visual-customizer.svg';
import React from 'react';
import config from 'src/shared/config';
import { backofficeUrl, T } from 'src/shared/helpers';

export const getTools = (isNewConfiguratorBackoffice: boolean) =>
    [
        {
            type: 'CUSTOMIZER',
            name: T._('Visual Product Customizer', 'Admin'),
            description: T._('Automate your printing or engraving process', 'Admin'),
            icon: <CustomizerMenuIcon />,
            isAI: false,
            isNew: false,
            isEarlyAccess: false,
            url: backofficeUrl('/Dashboard?from=customizer')
        },
        {
            type: 'CONFIGURATOR',
            name: T._('3D Product Configurator', 'Admin'),
            description: T._('Unique 3D shopping experience', 'Admin'),
            icon: <ConfiguratorMenuIcon />,
            isAI: false,
            isNew: false,
            isEarlyAccess: false,
            url: `${config.culture}/Composer?from=customizer`
        },
        {
            type: 'VIEWER',
            name: T._('3D DAM & AR Viewer', 'Admin'),
            description: T._('Manage, collaborate & share 3D/AR models', 'Admin'),
            icon: <DamMenuIcon />,
            isAI: false,
            isNew: false,
            isEarlyAccess: false,
            url: backofficeUrl('/DAM?page=/gallery')
        },
        {
            type: 'AI_STUDIO',
            name: T._('AI Agents Studio', 'Admin'),
            description: T._('Bring your products to life with AI-powered tools.', 'Admin'),
            icon: <AiStudioMenuIcon />,
            isAI: false,
            isNew: false,
            isEarlyAccess: false,
            url: backofficeUrl('/ai-creative-tools/studio')
        },
        ...(isNewConfiguratorBackoffice
            ? [
                  {
                      type: 'CONFIGURATOR_2',
                      name: T._('PC (backoffice unico)', 'Admin'),
                      description: T._('Unique 3D shopping experience', 'Admin'),
                      icon: <ConfiguratorMenuIcon />,
                      isAI: false,
                      isNew: true,
                      isEarlyAccess: true,
                      url: backofficeUrl('/Dashboard?from=configurator2')
                  }
              ]
            : [])
    ] as const;
